import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err.response?.data?.detail;
    if (Array.isArray(detail)) {
      err.friendlyMessage = detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
    } else if (typeof detail === "string") {
      err.friendlyMessage = detail;
    } else {
      err.friendlyMessage = "Something went wrong. Please try again.";
    }
    return Promise.reject(err);
  }
);

export default api;
